import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

//SERVICE
import { LandingService } from "./landing.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import *  as $ from 'jquery';
import Swal from 'sweetalert2';


export interface PeriodicElement {
  nameEncuesta: string;
  fechaInicio: string;
  fechaCerrar: string;
  avance: number;
  estado: string;
}

@Component({
    selector   : 'landing',
    templateUrl: './landing.component.html',
    styleUrls  : ['./landing.component.scss'],
    animations : fuseAnimations
})




export class LandingLeaderComponent implements OnInit, OnDestroy
{
  tipoProducto:string;

  idiomaActual:string;
  mensajesTraducirTS = {
    error1: '',
    error2: ''
  };
  mensajesTraducirKeys: string[] = [
    'SHEDULE.ERRORDATE',
    'SHEDULE.SAMEDATE'
  ];
  anioelejido= false;
  textoBanner= 'LANDINFOCUS.WIZARD.TITULO';
  mostrarEncuestas: backInter.getEncuestasFocus;

  ELEMENT_DATA: PeriodicElement[] = [
    {nameEncuesta: 'Evento de evaluación 2000', fechaInicio: '08/01/2020', fechaCerrar: '08/02/2020', avance: 50, estado: 'Programada'},
    {nameEncuesta: 'Evento de evaluación 2000', fechaInicio: '08/01/2020', fechaCerrar: '08/02/2020', avance: 50, estado: 'Programada'},
    {nameEncuesta: 'Evento de evaluación 2000', fechaInicio: '08/01/2020', fechaCerrar: '08/02/2020', avance: 50, estado: 'Programada'},

  ];
  displayedColumns: string[] = ['nameEncuesta', 'fechaInicio', 'fechaCerrar', 'avance', 'estado','accion'];
  dataSource = this.ELEMENT_DATA;
      origen: any;

    cargando = true;

    productos: any[] = [
        {
            'id'      : '1',
            'title'   : 'WIZARD.CERTIFICAR.TITULO',
            'welcome' : 'WIZARD.LANDING.PRODUCTO.CERTIFICAR.TITULO',
            'url' : 'certify',
            'category': 'CGO',
            'length'  : 30,
            'updated' : '9 Agosto 2019',
            'start' : 'WIZARD.CERTIFICAR.LANDING.ENTRAR'
        },
        {
            'id'      : '2',
            'title'   : 'WIZARD.MEDIR.TITULO',
            'welcome' : 'WIZARD.LANDING.PRODUCTO.MEDIR.TITULO',
            'url' : 'measurement',
            'category': 'Medir',
            'length'  : 30,
            'updated' : '26 Agosto 2019',
            'start' : 'WIZARD.MEDIR.LANDING.ENTRAR'
        },
        {
            'id'      : '3',
            'title'   : 'WIZARD.PULSE.TITULO',
            'welcome' : 'WIZARD.LANDING.PRODUCTO.PULSE.TITULO',
            'url' : 'pulse',
            'category': 'Pulse',
            'length'  : 30,
            'updated' : '26 Agosto 2019',
            'start' : 'WIZARD.PULSE.LANDING.ENTRAR'
        },
        {
            'id'      : '4',
            'title'   : 'WIZARD.FOCUS.TITULO',
            'welcome' : 'WIZARD.LANDING.PRODUCTO.FOCUS.TITULO',
            'url' : 'focus',
            'category': 'Focus',
            'length'  : 30,
            'updated' : '26 Agosto 2019',
            'start' : 'WIZARD.FOCUS.LANDING.ENTRAR'
        }
    ];

    producto: any;

    productosAsignados: any[]  =[];

    instituto: string;

    idiomaVideo:string;

    // Private
    private _unsubscribeAll: Subject<any>;

    productosPaquetes:any;
    productPa:boolean=false;

    tipoFocus:number;
   focusViejo:boolean=false;
   validationUserLeaderGo:boolean=false;
    constructor(
      private http:HttpClient,
      private landingService : LandingService,
      private activatedRoute:ActivatedRoute,
      private router: Router,
      private wizardService: WizardService,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private translateSrv: TranslateService){
        //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
        this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        lang_wizard.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        lang_focus.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaVideo(this.translateSrv.currentLang); });
    }

    ngOnInit(): void
    {
      this.activatedRoute.data.subscribe(params => {
        this.origen = params;
        this.productos.forEach( (producto) => {
          if(producto.id == this.origen.producto){
            this.producto = producto;
          }
        });
        this.obtieneInstituto();
        this.obtieneProductos();
        this.cambiaIdiomaVideo(this.translateSrv.currentLang);
        this.traduceTextosTS();

      });
    }
    traduceTextosTS(){
     let iter = 0;
     for(var k in this.mensajesTraducirTS){
       this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
         //console.log(k);
         this.mensajesTraducirTS[k] = res;
         // console.log(this.mensajesTraducirTS[k]);
       });
       iter++;
     }
     this.idiomaActual = this.translateSrv.currentLang;


   }


    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    cambiaIdiomaVideo(idioma:string){
      this.idiomaVideo = this.translateSrv.currentLang;
      switch(idioma){
        case 'es': this.idiomaVideo = idioma; break;
        default: this.idiomaVideo = 'en';
      }
      // $("#videoLanding").attr("src",'assets/video/landing/TODOS/' + this.producto.url + '_' + this.idiomaVideo + '.mp4');
      // $("#videoLanding").attr("poster",'assets/video/landing/TODOS/' + this.producto.url + '_' + this.idiomaVideo + '.jpg');
      // $("#videoLanding").attr("src",'assets/video/landing/TODOS/certify_' + this.idiomaVideo + '.mp4');
      // $("#videoLanding").attr("poster",'assets/video/landing/TODOS/certify_' + this.idiomaVideo + '.jpg');

      setTimeout(() => {
        if(this.idiomaVideo == 'es'){
          $("#videoLanding").attr("src",DATOS_API.urlAssets + 'video/landing/TODOS/focus.mov');
          $("#videoLanding").attr("poster",DATOS_API.urlAssets + 'video/landing/TODOS/focus.jpg');
        }
        else{
          $("#videoLanding").attr("src",DATOS_API.urlAssets + 'video/landing/TODOS/certify_' + this.idiomaVideo + '.mp4');
          $("#videoLanding").attr("poster",DATOS_API.urlAssets + 'video/landing/TODOS/certify_' + this.idiomaVideo + '.jpg');
        }
      }, 1000);
    }

    obtieneInstituto(){
      let institutoAct = this.wizardService.getInstituto();
      console.log(institutoAct);
      switch(institutoAct){
case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
      }
    }

    obtieneProductos(){
      this.wizardService.getProductos().subscribe( (respuesta: backInter.infoProductos) => {
        console.log("xsxas",respuesta);
        this.productosPaquetes=respuesta;

        let prods: any=[];
        let url: string;
        let nombre: string;
        switch(this.origen.producto){
          case '1': prods = respuesta.productosCertificar; url = 'certify'; nombre = 'CERTIFICAR'; break;
          case '2': prods = respuesta.productosMedir; url = 'measurement'; nombre = 'MEDIR'; break;
          case '3': prods = respuesta.productosPulseCheck; url = 'pulse'; nombre = 'PULSE'; break;
          case '4': prods = respuesta.productosFocusArea; url = 'focus'; nombre = 'FOCUS'; this.tipoFocus=1;this.focusViejo=false;
          this.tipoProducto='Focus';
          break;

          case 'f1': url = 'focus_t1'; nombre = 'FOCUS_1';
          this.tipoFocus=2;this.focusViejo=true;
          // this.tipoProducto='Focus';
          respuesta.productosCertificar.forEach(focus_1 => {
            if (focus_1.idProducto== 43) {
              prods.push(focus_1)
            }
          });
          break;

          case 'L1': url = 'leader_GO/wizard'; nombre = 'LEADER_GO';
   this.validationUserLeaderGo=false;
          respuesta.productosCertificar.forEach(leader_1 => {
            if (leader_1.idProducto== 53) {
              prods.push(leader_1)
            }
          });
          break;
          case 'LU1': url = 'leader_GO®_User'; nombre = 'LEADER_GO';
           this.validationUserLeaderGo=true;
          respuesta.productosCertificar.forEach(leader_1 => {
            if (leader_1.idProducto== 53) {
              prods.push(leader_1)
            }
          });
          break;

        }
        prods = this.ordenaDescendente(prods, this.origen.producto);
        // console.log(prods);
        this.colocaProductos(nombre,url,this.instituto,prods);
      });
    }

    // tipoPaquete(fechaFo){
    //   console.log(fechaFo);
    //   this.productosPaquetes.paquetes.forEach(element => {
    //     if (element.fecha==fechaFo) {
    //       console.log("encontro");
    //       this.productPa=true;
    //       console.log(this.productPa);
    //     }else{
    //       this.productPa=false;
    //       console.log(this.productPa);
    //
    //     }
    //
    //   });
    //
    //
    // }

    ordenaDescendente(datos:any, tipo:string){
      switch(tipo){
        case '1': datos.sort( (a,b) => { if(a.fechaCertificar < b.fechaCertificar){ return 1; } else{ return -1; } }); break;
        case '2': datos.sort( (a,b) => { if(a.fechaMedir < b.fechaMedir){ return 1; } else{ return -1; } }); break;
        case '3': datos.sort( (a,b) => { if(a.fechaPulseCheck < b.fechaPulseCheck){ return 1; } else{ return -1; } }); break;
        case '4': datos.sort( (a,b) => { if(a.fechaFocus < b.fechaFocus){ return 1; } else{ return -1; } }); break;
      }
      return datos;
    }

    colocaProductos(producto:string, url:string, instituto:string, datos:any){
      // console.log(datos);
      datos.forEach( (elem) => {
        let fecha:number;
        let idProducto:string;
        let completo: number;
        let tagStatus: string;
        switch(producto){
          case 'CERTIFICAR':
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar;
          break;
          case 'MEDIR':
            fecha = elem.fechaMedir; idProducto = elem.idMedir;
            completo = elem.completoMedir;
          break;
          case 'PULSE':
            fecha = elem.fechaPulseCheck; idProducto = elem.idPulseCheck;
            completo = elem.completoPulseCheck;
          break;
          case 'FOCUS':
            fecha = elem.fechaFocus; idProducto = elem.idFocusArea;
            completo = elem.completoFocusArea;
          break;
          case 'FOCUS_1':
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar;
          break;
          case 'LEADER_GO':
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar;
          break;
        }
        switch(completo){
          case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.CURRENT'; break;
          default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.FINISHED';
        }
        this.productosAsignados.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : fecha,
            url : url,
            instituto : instituto,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus
          }
        );
      });
      this.cargando = false;
      console.log('this.productosAsignados',this.productosAsignados)
    }



      navigateTo(ruta,fecha,instituto,productoID,encuestaID){
      localStorage.setItem('fechaProducto', fecha);
      localStorage.setItem('instituto', instituto);
      // localStorage.setItem('productoID', productoID);
      localStorage.setItem('encuestaID', encuestaID);
      this.router.navigate([ruta]);
      console.log(fecha +'/'+instituto+'/'+productoID+'/'+ ruta );

    }

      navigateToFocus(ruta,productoId,fecha,instituto){
      //   console.log(surveyProductoFocus);
      //
      localStorage.setItem('fechaProducto', fecha);
      localStorage.setItem('instituto', instituto);
      localStorage.setItem('productoID', productoId);
      // localStorage.setItem('surveyProductoFocus', surveyProductoFocus);
      this.router.navigate([ruta]);
      // console.log(fecha +'/'+instituto+'/'+productoID+'/'+ ruta );

    }




    mensajeSwal(mensaje:string, tipoMsg:number){
      let tipo: any;
      let rspSi = 'MODALES.ACCIONES.aceptar';
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      switch(tipoMsg){
        case 1: tipo = 'success'; break;
        case 2: tipo = 'warning'; break;
        case 3: tipo = 'error'; break;
      }
      Swal.fire({
        title: mensaje,
        icon: tipo,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }


}
